namespace HA.Core.Controller.Form {
    import Tag = HA.Core.HTML.Tag;
    import FSApp = HA.Core.Entity.FSApp;

    export class FormController extends Controller {
        /**
         *
         * @param id
         */
        public closeSelection(id: string) {
            getAppService().closeFSApp(id);
        }

        public showSelection(app: FSApp) {
            getAppService().showFSApp(app);
        }

        /**
         *
         * @param tag
         */
        public processBtnClick(tag: Tag) {
            const data = new Map();
            const form = new FormData();
            const me = this;
            const btn = tag.findElementByAttribute("formid");
            if (btn) {
                data.set("formId", btn.getAttribute("formid"));
                form.append("formId", btn.getAttribute("formid"));
            }
            this.getItemControllers().forEach((ic: FormItemController) => {
                if (ic.isInputItem()) {
                    if (ic instanceof MultiMediaController) {
                        const files: any[] = ic.getValue();
                        let i = 1;
                        const medias: any[] = [];

                        files.forEach((file: File | string) => {
                            if (file instanceof File) {
                                form.append("media_" + i, file);
                                ++i;
                            } else {
                                medias.push(file);
                            }
                        });

                        if (medias.length > 0) {
                            form.append("medias", JSON.stringify(medias));
                        }

                    } else if (ic instanceof FileController) {
                        const files: any[] = ic.getValue();
                        let i = 1;
                        const medias: any[] = [];

                        files.forEach((file: File | string) => {
                            if (file instanceof File) {
                                form.append("file_" + i, file);
                                ++i;
                            } else {
                                medias.push(file);
                            }
                        });

                        if (medias.length > 0) {
                            form.append("files", JSON.stringify(medias));
                        }

                    } else {
                        data.set(ic.getAttr("n"), ic.getValue());
                        form.append(ic.getAttr("n"), ic.getValue());
                    }
                }
            });

            getDataRepository().saveForm(form).then((response: Map<any, any>) => {
                const todo = response.get("todo");
                if (todo) {
                    switch (todo) {
                        case "success":
                            me.reset();
                            if (response.get("msg")) {
                                log(response.get("msg"));
                            }
                            if (response.get("id")) {
                                getWebPageService().reloadApp(response);
                            }
                            break;
                        case "app":
                            getWebPageService().reloadApp(response);
                            break;
                        case "error":
                            if (response.get("msg")) {
                                log(response.get("msg"));
                            }
                            break;
                        default:
                            getAppService().processAction(response);
                            break;
                    }
                } else if (response.has("app")) {
                    getWebPageService().showApp(response);
                } else {
                    getAppService().processAction(response);
                }
            }).catch((reason: any) => {
                log(["eRRRR", reason]);
            });
        }

        protected reset() {
            this.getItemControllers().forEach((ic: FormItemController) => {
                if (ic.isInputItem()) {
                    ic.reset();
                }
            });
        }

        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            this.initItems();
        }

        protected initItems() {
            const me = this;
            const formi = this.getTag().fetchByAttribute("formi");
            formi.forEach((item: Tag) => {
                me.addItemController(FormItemController.createController(toMap({tag: item, formController: me})));
            });
        }

        /**
         *
         * @param itemController
         */
        protected addItemController(itemController: FormItemController) {
            this.getItemControllers().set(itemController.getName(), itemController);
        }

        /**
         *
         * @returns {Map}
         */
        protected getItemControllers() {
            if (this.hasNot("itemControllers")) {
                this.addToData("itemControllers", new Map());
            }
            return this.get("itemControllers");
        }

    }
}
